<template>
<div :class="{ 'mb-3': enabled && !disableMargin }">
  <template v-if="!hideLabel || optional">
    <p v-if="customLabel" class="form-label">
      {{ customLabel }}
    </p>
    <p v-else class="form-label">
      <span v-if="optional" class="form-check form-switch">
        <input class="form-check-input" :id="`${id}_optional`" type="checkbox" role="switch" v-if="optional" v-model="enabled">
        <label class="form-check-label" :for="`${id}_optional`">{{ aLabel }}</label>
      </span>
      <template v-else>{{ aLabel }}</template>
    </p>
  </template>
  <slot v-if="!enabled" :inputId="id" :inputName="name" :label="aLabel" name="disabled">
    <input type="hidden" :name="name" value="">
  </slot>
  <template v-else>
    <slot :inputId="id" :inputName="name" :label="aLabel" :error="formattedError">

    </slot>
    <div v-if="formattedError" class="invalid-feedback">{{ formattedError }}</div>
    <div v-if="aHelp" class="text-muted">{{ aHelp }}</div>
  </template>
</div>
</template>

<script lang="ts">
import { humanize, scopeToId, scopeToName } from "@/lib/candidacy/form_builder/utils";
import type { BuildableItemError, PropType } from "@/types";
import { defineComponent } from "vue";

export default defineComponent({
  name: "FormGroup",
  props: {
    startsEnabled: {
      type: Boolean,
      default: true
    },
    optional: {
      type: Boolean,
      default: false,
    },
    scope: {
      type: Array as PropType<string[]>,
      required: true,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    help: {
      type: String,
    },
    errors: {
      type: Array as PropType<BuildableItemError[]>,
      default: [],
    },
    placeholder: {
      type: String,
      default: "",
    },
    disableMargin: {
      type: Boolean,
      default: false,
    },
    customLabel: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      enabled: !this.optional || this.startsEnabled,
    }
  },
  computed: {
    id() {
      return scopeToId(this.scope);
    },
    name() {
      return scopeToName(this.scope);
    },
    aLabel() {
      const field_name = this.scope[this.scope.length - 1];
      const key = `activerecord.attributes.candidacy/form_item.${field_name}`;
      return this.label || this.$te(key) ? this.$t(key) : humanize(field_name);
    },
    aHelp() {
      const field_name = this.scope[this.scope.length - 1];
      const key = `activerecord.help.candidacy/form_item.${field_name}`;
      return this.help || this.$te(key) ? this.$t(key) : "";
    },
    formattedError() {
      return this.errors ? this.errors.map((error: BuildableItemError) => error.message).join(", ") : "";
    }
  },
});
</script>
